import React, { FC } from 'react';
import { styled } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';

const AvatarStyled = styled(Avatar)(({ theme }) => ({
  border: `1px solid ${theme.palette.primary.main}`,
  background: 'none',
  color: theme.palette.primary.main,
}));

export const AvatarOutlined: FC = ({ children }) => <AvatarStyled>{children}</AvatarStyled>;
